import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders } from '@angular/core';
import { HelpManual } from './guide.model';

export interface SpectrumGuideConfig {
    /** The module's id, the same word its manual's topic ids start with: "finance". */
    module: string;
    /** The module's name as the menu shows it: "Finance". */
    title: string;
    /**
     * Loads the module's manual. Pass a dynamic import, so its text (often
     * hundreds of kilobytes) arrives in a chunk of its own the first time the
     * Guide needs it rather than in every page load:
     *
     *     manual: () => import('./help/finance.manual').then(m => m.FINANCE_MANUAL)
     */
    manual: () => Promise<HelpManual>;
}

export const SPECTRUM_GUIDE_CONFIG = new InjectionToken<SpectrumGuideConfig>('SPECTRUM_GUIDE_CONFIG');

/**
 * Turns the Guide on for an app. The app also mounts `<spectrum-guide />` once
 * in its shell and spreads `SPECTRUM_HELP_ROUTES` into its signed-in routes;
 * the shared header bar shows the Guide button by itself once this is
 * provided.
 */
export function provideSpectrumGuide(config: SpectrumGuideConfig): EnvironmentProviders {
    return makeEnvironmentProviders([{ provide: SPECTRUM_GUIDE_CONFIG, useValue: config }]);
}
